import React from 'react';
import { Image, useTheme } from '@aws-amplify/ui-react';
import Logo from '../../../assets/auth/logo.svg';
import styles from './css/style.module.css';

// src="https://arkdesign.ai/wp-content/uploads/2021/02/last-ark-1-1024x821.png"
function Header() {
  const { tokens } = useTheme();
  return (
    <div className={styles.box}>
      <Image
        alt="logo"
        src={Logo}
        padding={tokens.space.medium}
        width="400px"
        style={{ boxSizing: 'border-box' }}
      />
    </div>
  );
}

export default Header;
